import React from 'react';
import PropTypes from 'prop-types';
import css from './ErrorMessage.css';
import Icon from 'SF/MaterialIcon';

export default class ErrorMessage extends React.Component {

  get dismissButton() {
    if ( !this.props.onDismiss ) return null;
    return (
      <div
        onClick={this.props.onDismiss}
        aria-label="Dismiss"
        role="button"
        tabIndex="0">
        <Icon icon="close" />
      </div>
    );
  }

  render() {
    return (
      <div className={css['container']} role="alert">
        <div className={css['error-container']}>
          <div><Icon aria-hidden="true" icon="error"/></div>
          <div className={css['error-text']}>{this.props.message}</div>
        </div>
        {this.dismissButton}
      </div>
    );
  }
}

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func
}
